// extracted by mini-css-extract-plugin
export default {"InlineEditable":"_InlineEditable--FE94w","Focused":"_Focused--U9Zgb"};